import { Routes } from '@angular/router';
import { AppRoleGuardService } from '@app/auth/app-role-guard.service';
import { ScenarioReportsComponent } from './scenario-reports.component';
import { AuthConstants } from '@app/common/constants/AuthConstants';

let roles = AuthConstants.ROLES;

export const ReportsRoutes: Routes = [
  {
    path: 'home',
    component: ScenarioReportsComponent,
    canActivate: [AppRoleGuardService],
    data: {
      title: 'Reports',
      expectedRoles: [
        roles.Admin.name,
        roles.Projects.name,
        roles.Reporting.name,
        roles.ScheduleManagement.name
      ]
    }
  }
];